require("./bootstrap");
require("./mobile/react-native-link");
require("./mobile/push-registration");
require("./mobile/notification-app-settings");

require("../../../vendor/wire-elements/pro/resources/js/overlay-component.js");

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */
import Vue from "vue";
window.Vue = Vue;
Vue.config.ignoredElements = [
  /^ui-/,
];

import { RadarChart } from "./charts/radar-chart/radar-chart.js";
window.RadarChart = RadarChart;

document.addEventListener("alpine:init", () => {
  Alpine.directive("radar-chart", async (el, { expression }, { evaluate }) => {
    if (!window.d3) {
      await import(/* webpackChunkName: "js/d3" */ "./d3.js");
    }
    evaluate(expression);
  });
});

import router from "./router";
import store from "./store";

import VueProtectForm from "@thijsvdanker/vue-protect-form";
import PortalVue from "portal-vue";
import Clipboard from "v-clipboard";
import elementResizeDetectorMaker from "element-resize-detector";
import debounce from "debounce";
import lang from "./lang";
import { startCase, sum, round } from "lodash-es";
import { Flash } from "./util/flash-message/helper";
import VueMq from "vue-mq";
import { install } from "@github/hotkey";
import "@github/details-menu-element";

/**
 * Register components
 */
const components = require("./components.json");

for (const [name, file] of Object.entries(components)) {
  Vue.component(name, () =>
    import(/* webpackChunkName: "js/[request]" */ `./components/${file}`)
  );
}

Vue.component("query-wrapper", () =>
  import(
    /* webpackChunkName: "js/query-wrapper" */ "./util/query-sync/QueryWrapper.vue"
  )
);

Vue.component("create-match-form", () =>
  import(
    /* webpackChunkName: "js/[request]" */ "./modules/match/components/CreateMatchForm.vue"
  )
);
Vue.component("match-activate-container", () =>
  import(
    /* webpackChunkName: "js/[request]" */ "./modules/match/containers/Activate.vue"
  )
);
Vue.component("match-create-container", () =>
  import(
    /* webpackChunkName: "js/[request]" */ "./modules/match/containers/Create.vue"
  )
);
Vue.component("match-edit-container", () =>
  import(
    /* webpackChunkName: "js/[request]" */ "./modules/match/containers/Edit.vue"
  )
);

/**
 * Buefy Components
 */
import {
  ConfigProgrammatic,
  Toast,
  Datepicker,
  Loading,
  Tooltip,
  Field,
  Input,
  Tabs,
  Radio,
  Select,
  Button,
  Collapse,
} from "buefy";
Vue.use(Toast);
Vue.use(Datepicker);
Vue.use(Loading);
Vue.use(Tooltip);
Vue.use(Field);
Vue.use(Input);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Button);
Vue.use(Collapse);

ConfigProgrammatic.setOptions({
  defaultIconPack: "fas",
});

/**
 * Configuration
 */
Vue.use(VueProtectForm);
Vue.use(PortalVue);
Vue.use(Clipboard);
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints from bulma
    mobile: 768,
    tablet: 1023,
    desktop: 1215,
    widescreen: 1407,
    fullhd: Infinity,
  },
});
Vue.prototype.lang = lang;
Vue.prototype.startCase = startCase;
Vue.prototype.$flash = new Flash();
const erd = elementResizeDetectorMaker({ strategy: "scroll" });

import Rollbar from "rollbar";
if (window.RegiExtranetOptions.env === "production") {
  Vue.prototype.$rollbar = new Rollbar({
    accessToken: "6549d94a6ba24b4fb228ee240e261418",
    captureUncaught: true,
    enabled: true,
    captureUnhandledRejections: true,
    captureIp: false,
    payload: {
      environment: "production",
      client: {
        javascript: {
          code_version: "1.0",
          source_map_enabled: true,
          guess_uncaught_frames: true,
        },
      },
    },
    scrubFields: ["wachtwoord", "password", "password_confirmation"],
  });
  Vue.config.errorHandler = function (err, vm, info) {
    vm.$rollbar.error(err);
  };
}

Vue.prototype.RegistrationOptions = JSON.parse(
  window.RegiExtranetOptions.registration
);
Vue.prototype.RegiExtranetFeatures = JSON.parse(
  window.RegiExtranetOptions.features
);

window.showContactModal = function () {
  window.dispatchEvent(new CustomEvent("open-contact-form-modal"));
};

window.addEventListener("beforeunload", () => {
  if (window.innerWidth > 1024) {
    return;
  }

  if (document.querySelector(".horizontal-loading-indicator")) {
    return;
  }

  const indicator = document.createElement("div");
  indicator.classList.add("horizontal-loading-indicator");
  document.body.appendChild(indicator);
});

const RegiExtranetMenu = new Vue({
  router,
  store,
  el: "#main-menu",
  data: {
    pageFilters: {},
    isMobileNavActive: false,
    showMobileMenu: false,
    showVacaturesMenu: false,
    showActiviteitenMenu: false,
    showPrikbordMenu: false,
    windowWidth: window.innerWidth,
    showLogin: false,
    contentOverlay: false,
  },
  created() {
    this.$store.dispatch("UrlReadWrite/updateOnce");
    this.$store.dispatch("UrlReadWrite/startListening");
  },
  mounted() {
    this.showVacaturesMenu = this.$route.path.includes("vacatures");
    this.showPrikbordMenu = this.$route.path.includes("prikbord");
    this.showActiviteitenMenu = this.$route.path.includes("activiteiten");

    const mobileDropdown = () => {
      if (this.windowWidth <= 1024) {
        Array.prototype.forEach.call(
          document.querySelectorAll(".navbar-item.has-dropdow"),
          (dropdown) => {
            const button = dropdown.querySelector(".navbar-link");
            button.onclick = () => {
              dropdown.classList.toggle("expanded");
            };
            if (button.classList.contains("is-active")) {
              dropdown.classList.add("expanded");
            }
          }
        );
      }
    };

    // Can be used by setting 'data-scroll-target-mobile="<number of pixels>"'.
    // Will first scroll the top of the page to the referenced element, then
    // scroll vertically with an amount of <number of pixels>
    const mobileScrollIntoView = () => {
      if (this.windowWidth <= 1024) {
        const el = document.querySelector("[data-scroll-target-mobile]");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          window.scrollBy(0, el.getAttribute("data-scroll-target-mobile"));
        }
      }
    };

    const mobileSecondaryNavScrollIntoView = () => {
      if (this.windowWidth <= 1024) {
        const activeItem =
          document.querySelector(
            '.navbar-secondary-mobile [data-mobile-secondary-active="true"]'
          ) || document.querySelector(".navbar-secondary-mobile .navbar-item.is-active");

        if (activeItem) {
          activeItem.scrollIntoView({
            behavior: "auto",
            inline: "center",
            block: "nearest",
          });
        }
      }
    };

    mobileDropdown();
    mobileScrollIntoView();
    mobileSecondaryNavScrollIntoView();

    // Listen for window resize events
    window.addEventListener(
      "resize",
      debounce((e) => {
        // Update locally stored value so computed function recompute
        this.windowWidth = window.innerWidth;

        // Retest for mobile dropdown
        mobileDropdown();
      }, 100)
    );

    // Show mobile menu when logo width and menu width exceeds its container width.
    erd.listenTo(document.getElementById("header"), (el) => {
      const containerWidth = 1043;
      const logoWidth = document.getElementById("logo").offsetWidth;
      this.showMobileMenu =
        this.menuItemsWidth + logoWidth >= containerWidth || this.isTablet;
    });

    // Close mobile menu when registering a click on the background (overlay).
    document.addEventListener(
      "click",
      (e) => {
        if (this.showMobileMenu && e.target.classList.contains("overlay")) {
          if (this.isMobileNavActive) this.toggleMobileNav();
        }
      },
      false
    );

    // Set page height based on header height, so that footer aligns with bottom of the page
    const viewportHeight = window.innerHeight;
    const headerHeight = document.getElementById("header").offsetHeight;
    const footerHeight = document.getElementById("footer").offsetHeight;
    var mainHeight = document.getElementById("main").offsetHeight;
    mainHeight = Math.max(
      viewportHeight - headerHeight - footerHeight,
      mainHeight
    );
    document.getElementById("main").style["min-height"] = mainHeight + "px";

    // Install all the hotkeys on the page
    for (const el of document.querySelectorAll("[data-hotkey]")) {
      install(el);
    }
  },
  computed: {
    menuItems() {
      const loginItems = window.RegiExtranetOptions.userLoggedIn
        ? ["Start", window.RegiExtranetOptions.userName]
        : ["Inloggen"];
      return [
        "activiteiten",
        "declaraties",
        "prikbord",
        "vacatures",
      ]
        .filter((item) => {
          return this.RegiExtranetFeatures[item];
        })
        .concat(loginItems);
    },
    menuItemsWidth() {
      const charWidth = 8; //px
      const margin = 32; //px
      const lengths = this.menuItems.map(function (item) {
        const title = window.RegiExtranetOptions.titles[item] ?? item;
        return title.length * charWidth;
      });
      var extra = this.menuItems.length * margin; // width of margins of menu items
      if (window.RegiExtranetOptions.userLoggedIn) {
        extra += 50 + 24; //width of avatar and chevron
      }
      return round(sum(lengths)) + extra;
    },
    queryString() {
      return (
        "?" +
        Object.entries(this.pageFilters)
          .map((filter) => {
            return `${filter[0]}=${filter[1]}`;
          })
          .join("&")
      );
    },
    isMobile() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check || this.windowWidth < 769;
    },
    isTablet() {
      return this.isMobile || this.windowWidth < 1024;
    },
    showNavbarDropdowns() {
      // Only show navbar dropdowns when user is logged in; otherwise
      // there are not enough secondary-menu items to show.
      return (
        this.showMobileMenu &&
        this.isTablet &&
        window.RegiExtranetOptions.userLoggedIn
      );
    },
  },
  methods: {
    setScroll(scroll) {
      if (!scroll) {
        document.body.style.setProperty("height", "100vh");
        document.body.style.setProperty("overflow", "hidden");
      } else {
        document.body.style.removeProperty("height");
        document.body.style.removeProperty("overflow");
      }
    },
    setContentOverlay(overlay) {
      this.contentOverlay = overlay;
      this.setScroll(!this.contentOverlay);
    },
    toggleMobileNav() {
      this.isMobileNavActive = !this.isMobileNavActive;
      this.setContentOverlay(this.isMobileNavActive);
    },
    toggleMenuItem(showItem) {
      this.showVacaturesMenu =
        showItem === "vacatures" ? !this.showVacaturesMenu : false;
      this.showActiviteitenMenu =
        showItem === "activiteiten" ? !this.showActiviteitenMenu : false;
      this.showPrikbordMenu =
        showItem === "prikbord" ? !this.showPrikbordMenu : false;
    },
    toggleLoginModal() {
      this.showLogin = !this.showLogin;
    },
    changePage(page) {
      this.changeFilter("page", page);
    },
    changeFilter(key, value) {
      Vue.set(this.pageFilters, key, value);
      this.changeQuery();
    },
    changeQuery() {
      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          this.queryString;
        window.history.pushState({ path: newurl }, "", newurl);
        RegiExtranetMenu.$dispatch("filters-updated");
      }
    },
    gotoUrl(url) {
      window.location.href = url;
    },
  },
});

const RegiExtranet = new Vue({
  router,
  store,
  el: "#vue-app",
  data: {
    pageFilters: {},
    isMobileNavActive: false,
    showMobileMenu: false,
    showVacaturesMenu: false,
    showActiviteitenMenu: false,
    showPrikbordMenu: false,
    windowWidth: window.innerWidth,
    showLogin: false,
    contentOverlay: false,
  },
  created() {
    this.$store.dispatch("UrlReadWrite/updateOnce");
    this.$store.dispatch("UrlReadWrite/startListening");
  },
  mounted() {
    this.showVacaturesMenu = this.$route.path.includes("vacatures");
    this.showPrikbordMenu = this.$route.path.includes("prikbord");
    this.showActiviteitenMenu = this.$route.path.includes("activiteiten");

    // Can be used by setting 'data-scroll-target-mobile="<number of pixels>"'.
    // Will first scroll the top of the page to the referenced element, then
    // scroll vertically with an amount of <number of pixels>
    const mobileScrollIntoView = () => {
      if (this.windowWidth <= 1024) {
        const el = document.querySelector("[data-scroll-target-mobile]");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          window.scrollBy(0, el.getAttribute("data-scroll-target-mobile"));
        }
      }
    };

    const mobileSecondaryNavScrollIntoView = () => {
      if (this.windowWidth <= 1024) {
        const activeItem =
          document.querySelector(
            '.navbar-secondary-mobile [data-mobile-secondary-active="true"]'
          ) || document.querySelector(".navbar-secondary-mobile .navbar-item.is-active");

        if (activeItem) {
          activeItem.scrollIntoView({
            behavior: "auto",
            inline: "center",
            block: "nearest",
          });
        }
      }
    };

    mobileScrollIntoView();
    mobileSecondaryNavScrollIntoView();

    // Listen for window resize events
    window.addEventListener(
      "resize",
      debounce((e) => {
        // Update locally stored value so computed function recompute
        this.windowWidth = window.innerWidth;
      }, 100)
    );

    // Show mobile menu when logo width and menu width exceeds its container width.
    erd.listenTo(document.getElementById("header"), (el) => {
      const containerWidth = 1043;
      const logoWidth = document.getElementById("logo").offsetWidth;
      this.showMobileMenu =
        this.menuItemsWidth + logoWidth >= containerWidth || this.isTablet;
    });

    // Close mobile menu when registering a click on the background (overlay).
    document.addEventListener(
      "click",
      (e) => {
        if (this.showMobileMenu && e.target.classList.contains("overlay")) {
          if (this.isMobileNavActive) this.toggleMobileNav();
        }
      },
      false
    );

    // Set page height based on header height, so that footer aligns with bottom of the page
    const viewportHeight = window.innerHeight;
    const headerHeight = document.getElementById("header").offsetHeight;
    const footerHeight = document.getElementById("footer").offsetHeight;
    var mainHeight = document.getElementById("main").offsetHeight;
    mainHeight = Math.max(
      viewportHeight - headerHeight - footerHeight,
      mainHeight
    );
    document.getElementById("main").style["min-height"] = mainHeight + "px";

    // Install all the hotkeys on the page
    for (const el of document.querySelectorAll("[data-hotkey]")) {
      install(el);
    }
  },
  computed: {
    menuItems() {
      const loginItems = window.RegiExtranetOptions.userLoggedIn
        ? ["Start", window.RegiExtranetOptions.userName]
        : ["Inloggen"];
      return [
        "activiteiten",
        "declaraties",
        "prikbord",
        "vacatures",
      ]
        .filter((item) => {
          return this.RegiExtranetFeatures[item];
        })
        .concat(loginItems);
    },
    menuItemsWidth() {
      const charWidth = 8; //px
      const margin = 32; //px
      const lengths = this.menuItems.map(function (item) {
        const title = window.RegiExtranetOptions.titles[item] ?? item;
        return title.length * charWidth;
      });
      var extra = this.menuItems.length * margin; // width of margins of menu items
      if (window.RegiExtranetOptions.userLoggedIn) {
        extra += 50 + 24; //width of avatar and chevron
      }
      return round(sum(lengths)) + extra;
    },
    queryString() {
      return (
        "?" +
        Object.entries(this.pageFilters)
          .map((filter) => {
            return `${filter[0]}=${filter[1]}`;
          })
          .join("&")
      );
    },
    isMobile() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check || this.windowWidth < 769;
    },
    isTablet() {
      return this.isMobile || this.windowWidth < 1024;
    },
    showNavbarDropdowns() {
      // Only show navbar dropdowns when user is logged in; otherwise
      // there are not enough secondary-menu items to show.
      return (
        this.showMobileMenu &&
        this.isTablet &&
        window.RegiExtranetOptions.userLoggedIn
      );
    },
  },
  methods: {
    setScroll(scroll) {
      if (!scroll) {
        document.body.style.setProperty("height", "100vh");
        document.body.style.setProperty("overflow", "hidden");
      } else {
        document.body.style.removeProperty("height");
        document.body.style.removeProperty("overflow");
      }
    },
    setContentOverlay(overlay) {
      this.contentOverlay = overlay;
      this.setScroll(!this.contentOverlay);
    },
    toggleMobileNav() {
      this.isMobileNavActive = !this.isMobileNavActive;
      this.setContentOverlay(this.isMobileNavActive);
    },
    toggleMenuItem(showItem) {
      this.showVacaturesMenu =
        showItem === "vacatures" ? !this.showVacaturesMenu : false;
      this.showActiviteitenMenu =
        showItem === "activiteiten" ? !this.showActiviteitenMenu : false;
      this.showPrikbordMenu =
        showItem === "prikbord" ? !this.showPrikbordMenu : false;
    },
    toggleLoginModal() {
      this.showLogin = !this.showLogin;
    },
    changePage(page) {
      this.changeFilter("page", page);
    },
    changeFilter(key, value) {
      Vue.set(this.pageFilters, key, value);
      this.changeQuery();
    },
    changeQuery() {
      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          this.queryString;
        window.history.pushState({ path: newurl }, "", newurl);
        RegiExtranet.$dispatch("filters-updated");
      }
    },
    gotoUrl(url) {
      window.location.href = url;
    },
  },
});

document.querySelectorAll("[data-vue-island]").forEach((element) => {
  if (element.dataset.vueMounted !== undefined) {
    return;
  }

  element.dataset.vueMounted = "";

  new Vue({
    el: element,
  });
});
